import { KMF_APPLICATION_API_STATUS, KMF_APPLICATION_TOGGLE_TNC, SET_PURCHASE_RESPONSE, SET_QUOTE_RESPONSE, SET_REFERENCE_DATA_API_DETAILS_VALUE, SET_REFERENCE_DATA_VALUE } from '../../actions/kaMetlhaFuneralCover/referenceData';
import { API_CALL_STATUS } from '../status';

export const initReferenceData = {
    apiDetails: { status: API_CALL_STATUS.IDLE, name: null ,content:null},
    banks: [],
    branchCodes: [],
    termsandConditions: false,
    purchaseServiceResponse:{},
    quoteResponese:{},
    agentInfo: null
};

export default (state = initReferenceData, action) => {
    const updateField = (fieldType, value) => ({
        ...state,
        [fieldType]: value,
    });
    switch (action.type) {
        case SET_REFERENCE_DATA_VALUE:
            return updateField(action.value?.fieldType, action.value?.value);
        case SET_REFERENCE_DATA_API_DETAILS_VALUE:
            return {
                ...state, apiDetails:{...action.value}
            }
        case KMF_APPLICATION_TOGGLE_TNC:
            return{...state, termsandConditions:action.value}
        case KMF_APPLICATION_API_STATUS:
            return {...state, apiStatus: action.value };
        case SET_PURCHASE_RESPONSE:
            return {...state, purchaseServiceResponse: action.value };
        
        case SET_QUOTE_RESPONSE:
            return {...state, quoteResponese: action.value };
        default:
            return state;
    }
};
